import { defineComponent, reactive, toRefs, onMounted } from 'vue';
import { Table, Rate, Empty } from 'ant-design-vue/es';
export default defineComponent({
  components: {
    Empty,
    'a-table': Table,
    'a-rate': Rate
  },
  setup() {
    const columns = [{
      title: '投诉人',
      width: 180,
      dataIndex: 'contactPersonName',
      key: 'contactPersonName'
    }, {
      title: '车牌号',
      dataIndex: 'vehicleNo',
      width: 100,
      key: 'vehicleNo'
    }, {
      title: '问题描述',
      width: 220,
      dataIndex: 'exceptionRemark',
      key: 'exceptionRemark'
    }, {
      title: '投诉单号',
      key: 'shipmentCode',
      width: 200,
      dataIndex: 'shipmentCode'
    }, {
      title: '反馈时间',
      dataIndex: 'replyTime',
      key: 'replyTime',
      width: 150
    }, {
      title: '处理状态',
      dataIndex: 'shipmentComplaintStatus',
      key: 'shipmentComplaintStatus',
      width: 120
    }, {
      title: '处理结果说明',
      dataIndex: 'replyRemark',
      key: 'replyRemark',
      width: 300
    }];
    function createTableData() {
      const list = [];
      // for (let index = 0; index < 100; index++) {
      //   const o = {
      //     key: index + '',
      //     name: 'John Brown ' + index,
      //     age: 5 + index,
      //     address: '',
      //     pjtime: '状态' + index,
      //     expect:
      //       index +
      //       '运费支付慢,装卸货地点不真实,克扣运费,卸货等待时间长,装货等待时间长时间长,装货等待时间长====',
      //   }
      //   list.push(o)
      // }
      return list;
    }
    const data = createTableData();
    const state = reactive({
      columns,
      data
    });
    const phoneFormat = val => {
      return `${val.substring(0, 3)}****${val.substring(7, 11)}`;
    };
    const nameFormat = val => {
      return `${val.substring(0, 1)}*${val.substring(2, 10)}`;
    };
    const shipperFormat = val => {
      return `${val.substring(0, 2)}***${val.substring(5, 30)}`;
    };
    const list = [{
      contactPersonName: '高锡青',
      contactPersonPhone: '18691211968',
      vehicleNo: '陕KM3138',
      exceptionRemark: '挂车上传成功了为啥还异常',
      shipmentCode: 'YD260318041726566088',
      replyTime: '2026-03-19 20:27:15',
      shipmentComplaintStatus: '已处理',
      replyRemark: '已电话沟通，重新上传挂车证件'
    }
    // {
    //   contactPersonName: '薛张伟',
    //   contactPersonPhone: '13992985601',
    //   vehicleNo: '陕B53945',
    //   exceptionRemark: '其它车辆都结运费了，我的么见结',
    //   shipmentCode: 'YD260309016241846649',
    //   replyTime: '2026-03-12 00:06:59',
    //   shipmentComplaintStatus: '已处理',
    //   replyRemark: '运单磅单不清晰，已联系司机重新上传，运单审核通过后即付',
    // },
    ];

    onMounted(() => {
      // checkShipmentComplaint().then((res) => {
      //   //   console.log('checkShipmentComplaint', res)
      //   state.data = res
      // })
      state.data = list.map(item => {
        item.contactPersonPhone = phoneFormat(item.contactPersonPhone);
        item.contactPersonName = nameFormat(item.contactPersonName);
        item.vehicleNo = shipperFormat(item.vehicleNo);
        return item;
      });
    });
    return {
      ...toRefs(state)
    };
  }
});